// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentVerifySurveyEntryRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentVerifySurveyEntryRequestModel.attributeTypeMap;
    }
}
EnrollmentVerifySurveyEntryRequestModel.discriminator = undefined;
EnrollmentVerifySurveyEntryRequestModel.attributeTypeMap = [
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerKey",
        "baseName": "answerKey",
        "type": "number"
    },
    {
        "name": "answerText",
        "baseName": "answerText",
        "type": "string"
    }
];
//# sourceMappingURL=enrollmentVerifySurveyEntryRequestModel.js.map